import { BaseModel } from "../base.model";
import { AttendeeModel } from "./attendee.model";

export class CalendarEventModel extends BaseModel{
    title: string = "";
    category: string = "";
    location: string = "";
    description: string = "";
    start: Date|string|undefined; 
    end: Date|string|undefined;
    date: {from: Date|undefined, to: Date|undefined}| any = {from: undefined, to:undefined};
    startTime: String |undefined; 
    endTime: String |undefined; 
    allDayEvent: boolean | undefined; 
    attendees: AttendeeModel[] = []; 


    updateDate(){
        this.date.from = this.start;
        this.date.to = this.end;
    }
}